import { TrendingDown, Trophy, Sparkles, AlertTriangle } from "lucide-react";
import type { PriceBadge as PriceBadgeData } from "@/lib/price-badge";

const STYLES: Record<PriceBadgeData["kind"], { cls: string; Icon: typeof Trophy }> = {
  lowest: {
    cls: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 ring-emerald-500/30",
    Icon: Trophy,
  },
  great: {
    cls: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 ring-emerald-500/25",
    Icon: TrendingDown,
  },
  good: {
    cls: "bg-primary/10 text-primary ring-primary/25",
    Icon: Sparkles,
  },
  high: {
    cls: "bg-amber-500/10 text-amber-700 dark:text-amber-300 ring-amber-500/25",
    Icon: AlertTriangle,
  },
};

export function PriceBadge({
  badge,
  size = "sm",
  className,
}: {
  badge: PriceBadgeData | null | undefined;
  size?: "xs" | "sm";
  className?: string;
}) {
  if (!badge) return null;
  const { cls, Icon } = STYLES[badge.kind];
  const padding = size === "xs" ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-[11px]";
  const iconSize = size === "xs" ? "h-2.5 w-2.5" : "h-3 w-3";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ring-1 ${padding} ${cls} ${className ?? ""}`}
      title={
        typeof badge.deltaPct === "number"
          ? `${badge.label} (${badge.deltaPct > 0 ? "+" : ""}${badge.deltaPct}% vs średnia)`
          : badge.label
      }
    >
      <Icon className={iconSize} aria-hidden="true" />
      {badge.label}
    </span>
  );
}
